const crud = { c: false, r: false, u: false, d: false };

export const questionOwner = Object.freeze({
  editQuestionOwner: { ...crud },
});
